var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"media-heading"},[_c('span',{staticClass:"font-weight-bolder"},[_vm._v(" "+_vm._s(_vm.notification.title)+" ")])]),_c('small',{staticClass:"notification-text"},[_vm._v(_vm._s(_vm.notification.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }